export default __webpack_public_path__ + "static/media/blaze-branding-logo.02417000.svg";